// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GraduationCapIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m31.47 11.117-15-8a1 1 0 0 0-.94 0l-15 8a1 1 0 0 0 0 1.765L4 14.735v6.052c-.001.491.18.966.507 1.331C6.145 23.942 9.814 27 16 27a16.25 16.25 0 0 0 6-1.095V30a1 1 0 1 0 2 0v-5.061a14.452 14.452 0 0 0 3.492-2.822c.328-.365.509-.84.508-1.33v-6.053l3.47-1.851a1 1 0 0 0 0-1.765ZM16 25c-5.409 0-8.59-2.642-10-4.214V15.8l9.53 5.082a1 1 0 0 0 .94 0L22 17.934v5.792C20.425 24.461 18.44 25 16 25Zm10-4.219c-.6.665-1.27 1.263-2 1.782v-5.697l2-1.066v4.981Zm-2.5-5.913-.027-.017-7-3.734a1 1 0 0 0-.94 1.765L21.375 16 16 18.866 3.125 12 16 5.134 28.875 12 23.5 14.867Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
